import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=1dbdac7c&scoped=true"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"
import style0 from "./Burger.vue?vue&type=style&index=0&id=1dbdac7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbdac7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbdac7c')) {
      api.createRecord('1dbdac7c', component.options)
    } else {
      api.reload('1dbdac7c', component.options)
    }
    module.hot.accept("./Burger.vue?vue&type=template&id=1dbdac7c&scoped=true", function () {
      api.rerender('1dbdac7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Burger.vue"
export default component.exports